import { api } from "./api";

const CHUNK = 3 * 1024 * 1024;
export const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const VIDEO_TYPES = ["video/mp4", "video/webm"];

export async function uploadMedia(file, { folder = "media", onProgress } = {}) {
  const uploadId = Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(16).padStart(2, "0")).join("");
  const total = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < total; i++) {
    const fd = new FormData();
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), `${i}.part`);
    await api.post(`/admin/media/chunk?upload_id=${uploadId}&index=${i}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.(Math.round(((i + 1) / total) * 90));
  }
  const { data } = await api.post("/admin/media/complete", { upload_id: uploadId, filename: file.name, content_type: file.type, folder });
  onProgress?.(100);
  return data;
}

export function fmtSize(bytes) {
  if (!bytes) return "";
  return bytes > 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.round(bytes / 1024)} KB`;
}
